type ThrowBrowser = (name?: string) => void;

const throwBrowser: ThrowBrowser = (name) => {
  if (typeof window !== 'undefined') {
    throw new Error(`${name || 'this'} should not run on the browser`);
  }
};

export default throwBrowser;
